import logo from "./logo.svg";
import "./App.css";

function App() {
    return (
        <div className="privacy-policy">
            <h1>Privacy Policy</h1>

            <section>
                <h2>Introduction</h2>
                <p>
                    Welcome to Souls Progress Tracker. We are committed to
                    protecting your personal information and your right to
                    privacy. If you have any questions or concerns about our
                    policy, or our practices with regards to your personal
                    information, please contact us at{" "}
                    <a href="mailto:mattwellsblue42@gmail.com">
                        mattwellsblue42@gmail.com
                    </a>
                    .
                </p>
            </section>

            <section>
                <h2>Information We Collect</h2>
                <p>
                    We collect the following types of information in connection
                    with the services we provide:
                </p>
                <ul>
                    <li>
                        <strong>Personal Information:</strong> When you sign in
                        with Apple, Google, or create an account with email and
                        password, we collect the following information:
                        <ul>
                            <li>Email address</li>
                        </ul>
                    </li>
                    <li>
                        <strong>Game Progress Data:</strong> We keep a record of
                        your progress in the games you track using our app.
                    </li>
                    <li>
                        <strong>Advertising Data:</strong> We collect
                        information necessary to display personalized ads.
                    </li>
                </ul>
            </section>

            <section>
                <h2>How We Collect Information</h2>
                <p>We collect information in the following ways:</p>
                <ul>
                    <li>
                        <strong>Directly from You:</strong> When you provide it
                        to us through the sign-in process.
                    </li>
                    <li>
                        <strong>Automatically:</strong> Through the use of
                        cookies and similar tracking technologies for
                        personalized ads.
                    </li>
                </ul>
            </section>

            <section>
                <h2>How We Use Information</h2>
                <p>We use the collected information to:</p>
                <ul>
                    <li>Provide and maintain our services</li>
                    <li>Track your game progress</li>
                    <li>Display personalized ads</li>
                </ul>
            </section>

            <section>
                <h2>Sharing of Information</h2>
                <p>We may share your information with:</p>
                <ul>
                    <li>
                        <strong>Service Providers:</strong> To assist us in
                        providing services to you, such as authentication
                        services from Apple and Google.
                    </li>
                    <li>
                        <strong>Advertising Partners:</strong> To display
                        personalized ads.
                    </li>
                </ul>
            </section>

            <section>
                <h2>Data Protection</h2>
                <p>
                    We implement a variety of security measures to maintain the
                    safety of your personal information. These include
                    encryption, secure servers, and access controls.
                </p>
            </section>

            <section>
                <h2>User Rights</h2>
                <p>You have the right to:</p>
                <ul>
                    <li>Access your personal data</li>
                    <li>Correct any inaccuracies</li>
                    <li>Request deletion of your data</li>
                    <li>Opt-out of personalized ads</li>
                </ul>
            </section>

            <section>
                <h2>Changes to This Policy</h2>
                <p>
                    We may update our privacy policy from time to time. We will
                    notify you of any changes by posting the new policy on this
                    page.
                </p>
            </section>

            <section>
                <h2>Contact Us</h2>
                <p>
                    If you have any questions about this Privacy Policy, please
                    contact us at{" "}
                    <a href="mailto:mattwellsblue42@gmail.com">
                        mattwellsblue42@gmail.com
                    </a>
                    .
                </p>
            </section>

            <footer>
                <p>Effective Date: 7/9/2024</p>
            </footer>
        </div>
    );
}

export default App;
